import {useMutation, useQuery} from '@tanstack/react-query';

import {
  RQ_MEDICINE_ADD_API,
  RQ_MEDICINE_DELETE_API,
  RQ_MEDICINE_GET_ALL_API,
  RQ_MEDICINE_GET_API,
  RQ_MEDICINE_UPDATE_API,
} from './Constants';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url
    .replace(`<%= ${key} %>`, value)
    .replace('<%= medicineId %>', value),
});

export const RQMedicineAddAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_add_medicine'],
    mutationFn: async ({formData, token}) => {
      if (!formData) {
        throw new Error('formData is undefined');
      }

      return rqCreateRequest(
        RQ_MEDICINE_ADD_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });

export const RQMedicineUpdateAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_update_medicine'],
    mutationFn: async ({id, formData, token}) =>
      rqCreateRequest(
        withUrl(RQ_MEDICINE_UPDATE_API, 'id', id),
        formData,
        token,
        null,
      ),
    ...options,
  });

export const RQMedicineDeleteAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_delete_medicine'],
    mutationFn: ({id, token}) =>
      rqCreateRequest(
        withUrl(RQ_MEDICINE_DELETE_API, 'id', id),
        null,
        token,
        null,
      ),
    ...options,
  });

export const RQMedicineLookupByIdAPI = (
  id,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_medicine', id],
    queryFn: () =>
      rqCreateRequest(
        withUrl(RQ_MEDICINE_GET_API, 'id', id),
        null,
        token,
        null,
      ),
    enabled: !!id && !!token,
    ...options,
  });

export const RQMedicineLookupAllAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_medicines'],
    queryFn: () =>
      rqCreateRequest(
        RQ_MEDICINE_GET_ALL_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });
